const mode = "PROD";
const urls = {
  LOCAL: {
    base: "http://localhost:8080",
    upload: "http://localhost:8080/uploads",
  },
  PROD: {
    base: "https://api.scoutheim.com",
    upload: "https://api.scoutheim.com/uploads",
  },
  DEV: {
    base: "https://api.scout-heim.vytech.co",
    upload: "https://api.scout-heim.vytech.co/uploads",
  },
};
export const BASE_URL = urls[mode].base;
export const BASE_URL_UPLOAD = urls[mode].upload;
